export function renderPlaceholderPage(app: HTMLElement, title: string): void {
  app.innerHTML = `
    <div class="container">
      <div class="page-header">
        <h1>${title}</h1>
      </div>
      <div class="card">
        <p>This module is currently being migrated. Please check back soon.</p>
        <a href="/" class="btn">Back to Dashboard</a>
      </div>
    </div>
  `;
}
